export const MOBILE_SIZE = '(max-width:1279px)';